import {
  GetEnums,
  GetEnumsSuccess,
  GetEnumsFailed,
} from './enumeration.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { _Bottom } from '@angular/cdk/scrolling';
import { EnumsState } from './enumeration.model';
import { DpGetEnumsSuccess } from '../digital-payment/digital-payment.action';

export const initialState: EnumsState = {
  enumFields: [],
};

export function EnumsReducer(state: EnumsState | undefined, action: Action) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(
    GetEnumsSuccess,
    (state, { getEnumsResponse }) =>
      ({
        ...state,
        enumFields: getEnumsResponse,
      } as EnumsState)
  ),
  on(
    DpGetEnumsSuccess,
    (state, { getEnumsResponse }) =>
      ({
        ...state,
        enumFields: getEnumsResponse,
      } as EnumsState)
  ),
  on(
    GetEnumsFailed,
    (state, { error }) =>
      ({
        ...state,
        enumFields: [],
        error: error,
      } as EnumsState)
  )
);
